import {
  AfterViewInit,
  ComponentRef,
  Directive,
  ElementRef,
  HostBinding,
  inject,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  ViewContainerRef
} from '@angular/core';
import {AccValidator} from "./validator";
import {LoggingService} from "../../services/logger/logging.service";
import {notDefined} from "./epic.utils";
import {IconComponent} from "../icon/icon.component";

@Directive({selector: '[accExternalLink]', standalone: true})
export class ExternalLinkDirective implements OnInit, OnChanges, AfterViewInit {

  @HostBinding('attr.href')
  public hrefAttr: string = '';

  @HostBinding('attr.target')
  public targetAttr: string = '';

  @HostBinding('attr.rel')
  public relAttr: string = '';

  @Input({required: true})
  public href!: string;

  @Input()
  public target: string = '_blank';

  @Input()
  public rel: string = 'noopener nofollow';

  @Input()
  public showIcon: boolean = true;

  private readonly viewContainer = inject(ViewContainerRef);
  private readonly log = inject(LoggingService);
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly iconComponent: ComponentRef<IconComponent>;

  constructor() {
    this.iconComponent = this.viewContainer.createComponent(IconComponent);
    this.iconComponent.instance.name = 'hyperlink-external';
    this.iconComponent.instance.size = 'xxs';
    this.iconComponent.instance.styling = undefined;
  }

  ngOnInit(): void {
    this.updateAttributes();
  }

  ngOnChanges(): void {
    this.updateAttributes();
  }

  ngAfterViewInit(): void {
    if (this.showIcon) {
      this.addIcon();
    }
  }

  private updateAttributes(): void {
    if (notDefined(this.href)) {
      this.log.warn('ExternalLinkDirective: href is required');
      return;
    }

    if (this.notValidUrl(this.href)) {
      this.log.warn('ExternalLinkDirective: Invalid URL provided:', [this.href]);
      return;
    }

    this.hrefAttr = this.href;
    this.targetAttr = this.target;
    this.relAttr = this.rel;
  }

  private notValidUrl(url: string): boolean {
    return !AccValidator.isHyperlink(url);
  }

  private addIcon(): void {
    const iconElement: any = this.iconComponent.location.nativeElement;
    this.renderer.addClass(iconElement, 'ms-1');
    this.renderer.appendChild(this.el.nativeElement, iconElement);
  }
}
